import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Check, X, Calendar, Trash2 } from 'lucide-react';
import { getLeaveTypeLabel, LeaveStatusBadge } from '../../lib/leaves';
import { displayDate } from '../../lib/dates';

export const LeaveTable = ({ leaves, onStatusUpdate, onDelete }) => (
  <Card className="hidden md:block bg-white border border-[#D1D1CD] rounded-lg shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-[#F4F4F0]">
            <TableHead className="font-semibold text-[#1C1C1E]">Worker</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Type</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Dates</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] hidden md:table-cell">Reason</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Status</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {leaves.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center py-8 text-[#5C5C5C]">
                No leave requests found
              </TableCell>
            </TableRow>
          ) : (
            leaves.map((leave) => (
              <TableRow key={leave.id} data-testid={`leave-row-${leave.id}`}>
                <TableCell className="font-medium text-[#1C1C1E]">
                  {leave.worker_name}
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className="border-[#D1D1CD]">
                    {getLeaveTypeLabel(leave.leave_type)}
                  </Badge>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-1 text-sm text-[#5C5C5C]">
                    <Calendar className="w-4 h-4" />
                    {displayDate(leave.start_date)} to {displayDate(leave.end_date)}
                  </div>
                </TableCell>
                <TableCell className="hidden md:table-cell text-[#5C5C5C] text-sm">
                  {leave.reason || '-'}
                </TableCell>
                <TableCell>
                  <LeaveStatusBadge status={leave.status} />
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex items-center justify-end gap-2">
                    {leave.status === 'pending' && (
                      <>
                        <Button
                          variant="ghost"
                          size="icon"
                          data-testid={`approve-leave-${leave.id}`}
                          onClick={() => onStatusUpdate(leave.id, 'approved')}
                          className="h-10 w-10 text-[#2E4632] hover:bg-[#2E4632]/10"
                        >
                          <Check className="w-4 h-4" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="icon"
                          data-testid={`reject-leave-${leave.id}`}
                          onClick={() => onStatusUpdate(leave.id, 'rejected')}
                          className="h-10 w-10 text-[#BC4749] hover:bg-[#BC4749]/10"
                        >
                          <X className="w-4 h-4" />
                        </Button>
                      </>
                    )}
                    <Button
                      variant="ghost"
                      size="icon"
                      data-testid={`delete-leave-${leave.id}`}
                      onClick={() => onDelete(leave.id)}
                      className="h-10 w-10 text-[#5C5C5C] hover:text-[#BC4749] hover:bg-[#BC4749]/10"
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  </Card>
);
